import TakePhoto from './TakePhoto'
export default TakePhoto
